import React, { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Autorenew from "@mui/icons-material/Autorenew";
import IconButton from "@mui/material/IconButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Edithost from "./Edit";
import HostManagement from "./HostManagement.js";
import Template from "./Template";

const CustomerListResults = ({
  customers,
  del,
  Connect,
  oneopen,
  searchitems,
  ...rest
}) => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const cloumnName = "hostname";

  return (
    <Card {...rest}>
         
      <CardHeader action={<HostManagement />} title="HOST LIST" />
      <Paper sx={{ width: "100%" }}>
        <TableContainer sx={{ maxHeight: 1050 }}>
          <Table style={{ minWidth: 1050 }}>
            <TableHead className="bg-lightBlue-200">
              <TableRow>
                <TableCell align="center">S.No</TableCell>
                <TableCell align="center">Host Name</TableCell>
                <TableCell align="center">IP / DNS</TableCell>
                <TableCell align="center">Platforms</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Run</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers
                .slice(page * limit, page * limit + limit)
                .filter((val) => {
                  if (searchitems == "") {
                    return val;
                  } else if (
                    val[cloumnName]
                      .toLowerCase()
                      .includes(searchitems.toLowerCase())
                  ) {
                    return val;
                  }
                })
                .map((customer) => (
                  <TableRow hover key={customer.id}>
                    <TableCell align="center">
                      {customer.serial_number}
                    </TableCell>
                    <TableCell align="center">{customer.hostname}</TableCell>
                    <TableCell align="center">{`${customer.ip_dns}`}</TableCell>
                    <TableCell align="center">
                      {customer.platform ? customer.platform : "-"}
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={customer.status}
                        color={
                          customer.status === "connected" ? "success" : "error"
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      {customer.status === "connected" ? (
                        <Template HostID={customer.id} />
                      ) : (
                        <button
                          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                          type="button"
                          disabled="true"
                        >
                          Run Audit
                        </button>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        title="Log"
                        aria-label="log"
                        id="log"
                        style={{
                          padding: "0px",
                          color: "#dca43e",
                          marginTop: "-3px",
                        }}
                      >
                        <Link
                          to={{
                            pathname: "/admin/hostlog",
                          }}
                          onClick={() => {
                            window.sessionStorage.setItem(
                              "hostID",
                              customer.id
                            );
                          }}
                          style={{ color: "#ffffff" }}
                        >
                          <InsertDriveFileIcon
                            fontSize="small"
                            style={{ color: "#1ab1e8" }}
                          />
                        </Link>
                      </IconButton>

                      {window.localStorage.getItem("audit_run_access") ===
                      "You do not have permission to perform this action." ? (
                        ""
                      ) : (
                        <React.Fragment>
                          {/\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/.test(
                            customer.ip_dns
                          ) ? (
                            <Edithost HostID={customer.id} IPDNS="ipaddress" />
                          ) : (
                            <Edithost HostID={customer.id} IPDNS="domainname" />
                          )}

                          <IconButton
                            title="Re-Connect"
                            aria-label="re-connect"
                            id="connect"
                            style={{
                              padding: "0px",
                              color: "#70ad72e8",
                            }}
                          >
                            <Autorenew
                              fontSize="small"
                              color="#ff6347"
                              onClick={Connect(customer.id)}
                            />
                          </IconButton>
                          <IconButton
                            title="Delete"
                            aria-label="delete"
                            id="delete"
                            style={{
                              padding: "0px",
                              color: "#e68383",
                            }}
                          >
                            <DeleteIcon
                              fontSize="small"
                              onClick={() => {
                                oneopen();
                                window.sessionStorage.setItem(
                                  "specifyhostname",
                                  customer.hostname
                                );
                                del(customer.id);
                              }}
                            />
                          </IconButton>
                        </React.Fragment>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={customers.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </Card>
  );
};

export default CustomerListResults;